import { useState, useEffect } from 'react';
import { MenuItem, Grid } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomSelect,
  CustomTextArea,
} from '../../../../common/components';
import { INITIAL_TEMPLATE_STATE, TEMPLATE_TYPE_OPTIONS } from '../constants/taskTemplatesConstants';
import { validateTemplateData } from '../utils/taskTemplatesUtils';

/**
 * Diálogo para crear/editar plantillas de tareas
 */
const TaskTemplateDialog = ({ open, onClose, onSave, selectedTemplate, editMode }) => {
  const [formData, setFormData] = useState(INITIAL_TEMPLATE_STATE);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      if (editMode && selectedTemplate) {
        setFormData({
          name: selectedTemplate.name || '',
          description: selectedTemplate.description || '',
          template_type: selectedTemplate.template_type || 'progress',
        });
      } else {
        setFormData(INITIAL_TEMPLATE_STATE);
      }
      setErrors({});
    }
  }, [open, editMode, selectedTemplate]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSubmit = async () => {
    const validationErrors = validateTemplateData(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      await onSave(formData);
    } catch (error) {
      console.error('Error saving template:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <DialogContainer open={open} onClose={handleClose} size="small" maxWidth="90%">
      <DialogTitle>
        {editMode ? 'Editar Plantilla de Tareas' : 'Nueva Plantilla de Tareas'}
      </DialogTitle>

      <DialogBody sx={{ padding: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <CustomTextField
              label="Nombre"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              error={!!errors.name}
              helperText={errors.name}
              required
              fullWidth
              placeholder="Ingrese el nombre"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomSelect
              label="Tipo de Plantilla"
              name="template_type"
              value={formData.template_type}
              onChange={handleInputChange}
              error={!!errors.template_type}
              required
              fullWidth
            >
              {TEMPLATE_TYPE_OPTIONS.slice(1).map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
          <Grid item xs={12}>
            <CustomTextArea
              label="Descripción"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              error={!!errors.description}
              helperText={errors.description}
              multiline
              rows={3}
              fullWidth
              placeholder="Ingrese una descripción opcional"
            />
          </Grid>
        </Grid>
      </DialogBody>

      <DialogActions handleClose={handleClose} handleSave={handleSubmit} />
    </DialogContainer>
  );
};

export default TaskTemplateDialog;
